import { FC } from "react";
import PlaylistAddCheckOutlinedIcon from "@mui/icons-material/PlaylistAddCheckOutlined";
import { Toolbar } from "@mui/material";
import {
	DeleteButton,
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	ResetButton,
	SubmitButton,
} from "@websential/cosmic-v20";
// import { EnhancedButtonPrimeReact } from "../../EnhancedButtonPrimeReact";
// import { EnhancedButtonPrimeReactSeverity } from "../../../common/Common";

export interface IROEWebToolbar {
	onMarkAsSubmittedClicked: () => void;
	onDeleteClicked: () => void;
	isSubmitting: boolean;
	id?: any;
	// onGenerateROEXMLClicked: () => void;
}

export const ROEWebToolbar: FC<IROEWebToolbar> = ({
	onMarkAsSubmittedClicked,
	onDeleteClicked,
	isSubmitting = false,
	id,
	// onGenerateROEXMLClicked
}) => {
	return (
		<Toolbar>
			<>
				<EnhancedButtonPrimeReact
					label="Create ROE Web File"
					loading={isSubmitting}
					type="submit"
					// icon="pi pi-check"
					raised
					severity={EnhancedButtonPrimeReactSeverity.Success}
					// onClickHandler={onGenerateROEXMLClicked}
				/>
				<EnhancedButtonPrimeReact
					// icon="pi pi-plus"
					label="Mark as Submitted"
					raised
					loading={isSubmitting}
					// type="submit"
					onClickHandler={onMarkAsSubmittedClicked}
					style={{ marginLeft: "1rem" }}
					severity={EnhancedButtonPrimeReactSeverity.Secondary}
				/>
			</>
		</Toolbar>
	);
};
